// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"d2a57058","793":"81516f87","815":"69a99081"}[chunkId] + ".chunk.css";
};